<template>
  <Panel name="اطلاعات فروشگاه" class="mt-10">
    <form action="">
      <Input type="text" placeholder="نام فروشگاه" v-model="shop.name" />

      <Input type="tel" placeholder="تلفن" v-model="shop.phone" />

      <Input type="text" placeholder="آدرس" v-model="shop.address" />

      <!-- <div class="flex items-center">
        <Input
          type="text"
          placeholder="مختصات"
          v-model="shop.address"
          :value="shop.location.latitude + '' + shop.location.longitude"
          disabled
        />
        <Button class="mr-2" @click.prevent.stop="getLocation">
          <LocationMarkerIcon class="h-5 w-5" />
        </Button>
      </div>
      <span class="text-red-500 text-xs" v-if="shop.locationError">{{
        shop.locationError
      }}</span> -->
      <Select v-model="shop.economic">
        <option value="" selected disabled>وضعیت اقتصادی منطقه فروشگاه</option>
        <option value="ضعیف">ضعیف</option>
        <option value="متوسط">متوسط</option>
        <option value="خوب">خوب</option>
        <option value="خیلی خوب">خیلی خوب</option>
      </Select>
      <Select v-model="shop.meterage">
        <option value="" selected disabled>متراژ فروشگاه</option>
        <option value="0">10 تا 30</option>
        <option value="1">31 تا 70</option>
        <option value="2">71 تا 150</option>
        <option value="3">151 تا 300</option>
        <option value="4">بیش از 300</option>
      </Select>
      <Select v-model="shop.locshop">
        <option value="" selected disabled>موقعیت مکانی فروشگاه</option>
        <option value="کوچه">داخل کوچه</option>
        <option value="فرعی">حاشیه خیابان فرعی</option>
        <option value="اصلی">حاشیه خیابان اصلی</option>
        <option value="بلوار">حاشیه بلوار</option>
      </Select>
      <Select v-model="shop.sizeshop">
        <option value="" selected disabled>سایز فروشگاه</option>
        <option value="بقالی">بقالی</option>
        <option value="سوپر مارکت">سوپر مارکت</option>
        <option value="هایپر شخصی">هایپر شخصی</option>
        <option value="هایپر زنجیره ای">هایپر زنجیره ای</option>
      </Select>

      <router-link to="/survey/product-survey">
        <Button class="w-full mt-4" @click="submitShopInfo">ادامه</Button>
      </router-link>
    </form>
  </Panel>
</template>

<script>
import Input from "../../components/Input";
import Select from "../../components/Select";
import Button from "../../components/Button";
import Panel from "../../components/Panel";
// import { LocationMarkerIcon } from "@heroicons/vue/outline";

export default {
  name: "ShopInfo",
  components: { Panel, Button, Select, Input },
  data() {
    return {
      shop: this.$store.state.survey.shop,
    };
  },
  methods: {
    // getLocation() {
    //   if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition(
    //       (location) => {
    //         this.shop.location = location.coords;
            
    //       },
    //       (error) => {
    //         this.shop.locationError =
    //           "خطا در دریافت مختصات، از روشن بودن GPS اطمینان حاصل کنید.";
    //         console.log(error);
    //       }
    //     );
    //   } else {
    //     this.shop.locationError = "مرورگر شما از GPS پشتیبانی نمیکند.";
    //   }
    // },
    submitShopInfo() {
      this.$store.dispatch("setShopInfo", this.shop);
    },
  },
  watch: {
    "shop.type"() {
      if (this.shop.type === "عمده فروشی") {
        this.shop.sub_type = "";
      }
    },
  },
};
</script>

<style scoped></style>
